import React, { useContext, useEffect } from 'react';
import { ProgressIndicator } from '@fluentui/react';

import { Fail } from '../../common/Fail';
import { useDeployment } from 'hooks/api';
import { Title } from 'components/common/Title';
import { StepProps } from 'components/deployment/Deployment';
import { stepStyles as styles } from '../../steps/commonStyles';
import { StepContainer } from 'components/common/steps/StepContainer';
import { WarningMessage } from 'components/common/WarningMessage';
import { ApiError } from 'services/restService';
import { promptBeforeUnloadListener } from 'utils/browser';
import TranslationsContext from 'translations/TranslationsContext';
import translationKeys from 'translationKeys';
import translationsProvider from 'translations/translationsProvider';

export const AzureConfiguration = ({ checkCanGoNext, deployment, setStepError, goToNextStep }: StepProps) => {
	const { t } = useContext(TranslationsContext)!;
	const [currentDeployment] = useDeployment(deployment);

	const { error, isLoading } = currentDeployment;

	useEffect(() => {
		if (error) {
			setStepError(error);
		} else {
			const unsubscribe = promptBeforeUnloadListener();
			return unsubscribe;
		}
	}, [error]);

	useEffect(() => {
		if (!isLoading && !error) {
			goToNextStep();
		}
	}, [isLoading, error]);

	useEffect(() => {
		checkCanGoNext(false);
	}, []);

	if (error) return renderFail(error);

	return (
		<StepContainer className={styles.root}>
			<Title>{t(translationKeys.AzureConfiguration.Step.Default.Title)}</Title>
			<p className={styles.formElement}>{t(translationKeys.AzureConfiguration.Step.Default.Paragraph)} </p>
			<WarningMessage className={styles.formElement} isIcon>{t(translationKeys.AzureConfiguration.Step.Default.WarningMessage)}</WarningMessage>
			<ProgressIndicator className={styles.progress} label={t(translationKeys.AzureConfiguration.Default.ProgressIndicator.Label)} />
		</StepContainer>
	);
};

const renderFail = (error: ApiError) => (
	<StepContainer className={styles.root}>
		<Fail
			className={styles.stretchedContainer}
			error={error}
			title={translationsProvider.staticTranslate(translationKeys.AzureConfiguration.Step.Fail.Title)}
			detail={translationsProvider.staticTranslate(translationKeys.AzureConfiguration.Step.Fail.Detail)}
		/>
	</StepContainer>
);
